<template>
  <div class="contact-info dbox">
    <div class="form-group" v-if="accountingInfo.contact">
      <TextField
        :id="'tax_no'"
        v-bind="textFieldConfig"
        :value="accountingInfo.contact.tax_no"
        :placeholder="$t('tax_no')"
        @valuechanged="onTextFieldValueChange"
      />
      <v-layout row wrap class="vat-id">
        <v-flex xs6>
          <TextField
            :id="'vat_no'"
            v-bind="textFieldConfig"
            :value="accountingInfo.contact.vat_no"
            :placeholder="$t('vat_id')"
            @valuechanged="onTextFieldValueChange"
          />
        </v-flex>
        <v-flex xs6 style="margin-top: -5px">
          <div class="loading-icon" v-if="vatIdValidityLoading">
            <img src="static/icons/loading.gif" alt="" />
          </div>
          <button
            class="dt-button v1"
            @click="onVatValButtonClick"
            v-if="!vatIdValidityLoading"
            :class="{
              c1: this.vatIdValidity,
              c3: !this.vatIdValidity,
            }"
          >
            {{ vatIdValidity ? $t('vat_id_is_valid') : $t('vat_id_is_invalid') }}
          </button>
        </v-flex>
      </v-layout>
    </div>
  </div>
</template>

<script>
import TextField from "@plugins/text-field/text-field";
import Dropdown from "@plugins/dropdown/dropdown";

import { EventHooks } from "../../../../plugins/text-field";
import { ContactsService } from "../../services/contacts.service";
import { checkVATNumber } from "../../models/vat.model";

export default {
  components: {
    TextField,
    Dropdown,
  },
  props: {
    accountingInfo: {
      type: Object,
      required: true,
    },
  },
  data: function () {
    return {
      textFieldConfig: {
        height: 42,
        showEditIconOnHover: false,
        box: true,
        showValidationIcons: false,

        validationEvent: EventHooks.OnBlur,
        valueChangedEvent: EventHooks.OnBlur,
      },
      vatIdValidity: false,
      vatIdValidityLoading: null,
    };
  },
  watch: {
    accountingInfo: {
      immediate: true,
      handler: function (to, from) {
        if (to.check_vat_id) {
          this.vatIdValidity = to.check_vat_id == 0 ? false : true;
        }
      },
    },
  },
  computed: {
    isCompany: function () {
      return this.contact.contact.company_name;
    },
  },
  methods: {
    onTextFieldValueChange: function (name, value) {
      this.$emit("changed", { name, value });
      switch (name) {
        case "vat_no": {
          this.vatIdValidityLoading = true;
          ContactsService.checkVatIdFlag({
            vat_no: value,
            contact_id: this.accountingInfo.contact.contact_id,
          }).then((res) => {
            this.vatIdValidity = res.data.valid == "0" ? false : true;
            this.vatIdValidityLoading = false;
          });
          break;
        }
        default: {
        }
      }
    },
    onDropdownChange: function (name, value) {
      this.$emit("changed", { name, value: value.value });
    },
    onVatValButtonClick: function () {
      checkVATNumber(this.accountingInfo.contact.vat_no || "");
    },
  },
};
</script>

<style lang="scss" scoped>
.vat-id {
  .loading-icon {
    margin-top: 20px;
    text-align: center;
  }

  @media screen and (min-width: 320px) and (max-width: 480px) {
    .dt-button {
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
      max-width: 130px;
    }
  }
}
</style>
